/**
 * CUSTOM UPLOAD FIELDS - Padloom Design
 * v2.0 - For Minimog Theme
 */

(function() {
  'use strict';

  // Locale detection — German market (/de/ path or <html lang="de">)
  var __lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var IS_DE = __lang.indexOf('de') === 0 || /^\/de(\/|$)/.test(location.pathname);
  var T = IS_DE ? {
    addImage: 'Bild hinzufügen',
    title: 'Bild hierher ziehen & ablegen',
    subtitle: 'oder klicke, um von deinem Gerät auszuwählen',
    choose: 'Datei auswählen',
    formats: 'PNG, JPG, JPEG, GIF bis zu 10MB',
    success: 'Bild erfolgreich hochgeladen!',
    addNote: 'Notiz hinzufügen',
    notePlaceholder: 'Schreibe deine Notizen hier...',
    optional: 'Optional',
    hint: 'Besondere Anweisungen für den Designer'
  } : {
    addImage: 'Add your image',
    title: 'Drag & Drop Your Image',
    subtitle: 'or click to browse from your device',
    choose: 'Choose File',
    formats: 'PNG, JPG, JPEG, GIF up to 10MB',
    success: 'Image uploaded successfully!',
    addNote: 'Add Note',
    notePlaceholder: 'Write your notes here...',
    optional: 'Optional',
    hint: 'Special instructions for designer'
  };

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      initCustomUpload();
      initCustomNote();
    }, 100);
  });

  // =====================
  // CUSTOM UPLOAD FIELD
  // =====================
  function initCustomUpload() {
    // Find image upload fields - Minimog specific
    const fileFields = document.querySelectorAll('[data-product-custom-field="image_field"]');
    
    fileFields.forEach(function(field) {
      if (field.dataset.customized === 'true') return;
      field.dataset.customized = 'true';
      
      const fileInput = field.querySelector('input[type="file"]');
      const label = field.querySelector('label, .m-product-option--label');
      
      if (!fileInput) return;
      
      // Get label text
      const labelText = label ? label.textContent.trim() : T.addImage;
      const isRequired = fileInput.hasAttribute('required');
      
      // Hide original elements
      if (label) label.style.display = 'none';
      fileInput.style.display = 'none';
      
      // Create custom upload HTML
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-upload-container';
      wrapper.innerHTML = `
        <div class="custom-upload-label">
          <span class="custom-upload-label__text">${labelText}</span>
          ${isRequired ? '<span class="custom-upload-label__required">*</span>' : ''}
        </div>
        <div class="custom-upload-box" id="uploadBox_${fileInput.id}">
          <div class="custom-upload-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
          </div>
          <div class="custom-upload-content">
            <p class="custom-upload-title">${T.title}</p>
            <p class="custom-upload-subtitle">${T.subtitle}</p>
            <span class="custom-upload-btn">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="17 8 12 3 7 8"/>
                <line x1="12" y1="3" x2="12" y2="15"/>
              </svg>
              ${T.choose}
            </span>
            <div class="custom-upload-formats">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
              </svg>
              <span>${T.formats}</span>
            </div>
          </div>
          <div class="custom-upload-preview">
            <div class="custom-upload-file">
              <div class="custom-upload-file__thumb">
                <img src="" alt="Preview">
              </div>
              <div class="custom-upload-file__info">
                <p class="custom-upload-file__name"></p>
                <p class="custom-upload-file__meta">
                  <span class="file-size"></span>
                  <span class="file-type"></span>
                </p>
              </div>
              <button type="button" class="custom-upload-file__remove">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
            <div class="custom-upload-success">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              <span>${T.success}</span>
            </div>
          </div>
        </div>
      `;
      
      // Insert wrapper at beginning of field
      field.insertBefore(wrapper, field.firstChild);
      
      // Get elements
      const uploadBox = wrapper.querySelector('.custom-upload-box');
      const thumbImg = wrapper.querySelector('.custom-upload-file__thumb img');
      const fileName = wrapper.querySelector('.custom-upload-file__name');
      const fileSize = wrapper.querySelector('.file-size');
      const fileType = wrapper.querySelector('.file-type');
      const removeBtn = wrapper.querySelector('.custom-upload-file__remove');
      
      // Click to upload
      uploadBox.addEventListener('click', function(e) {
        if (e.target.closest('.custom-upload-file__remove')) return;
        fileInput.click();
      });
      
      // File change event
      fileInput.addEventListener('change', function(e) {
        const file = e.target.files[0];
        
        if (file) {
          // Show preview
          uploadBox.classList.add('has-file');
          
          // Set file info
          fileName.textContent = file.name;
          fileSize.textContent = formatFileSize(file.size);
          fileType.textContent = file.type.split('/')[1].toUpperCase();
          
          // Create image preview
          if (file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function(e) {
              thumbImg.src = e.target.result;
            };
            reader.readAsDataURL(file);
          }
        }
      });
      
      // Remove file
      removeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        fileInput.value = '';
        uploadBox.classList.remove('has-file');
        thumbImg.src = '';
        fileName.textContent = '';
        fileSize.textContent = '';
        fileType.textContent = '';
      });
      
      // Drag & Drop
      uploadBox.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.add('dragging');
      });
      
      uploadBox.addEventListener('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.remove('dragging');
      });
      
      uploadBox.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.remove('dragging');
        
        const files = e.dataTransfer.files;
        if (files.length > 0 && files[0].type.startsWith('image/')) {
          // Create a new DataTransfer to set files
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(files[0]);
          fileInput.files = dataTransfer.files;
          fileInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // =====================
  // CUSTOM NOTE FIELD
  // =====================
  function initCustomNote() {
    // Find textarea fields - Minimog specific
    const textareaFields = document.querySelectorAll('[data-product-custom-field="textarea"]');
    
    textareaFields.forEach(function(field) {
      if (field.dataset.customized === 'true') return;
      field.dataset.customized = 'true';
      
      const textarea = field.querySelector('textarea');
      const label = field.querySelector('label, .m-product-option--label');
      
      if (!textarea) return;
      
      // Get label text
      const labelText = label ? label.textContent.trim() : T.addNote;
      const isOptional = labelText.toLowerCase().includes('optional');
      const isRequired = textarea.hasAttribute('required');
      const maxLength = 500;
      const placeholder = textarea.placeholder || T.notePlaceholder;
      
      // Hide original elements
      if (label) label.style.display = 'none';
      textarea.style.display = 'none';
      
      // Create custom note HTML
      const wrapper = document.createElement('div');
      wrapper.className = 'custom-note-wrapper';
      wrapper.innerHTML = `
        <div class="custom-note-label">
          <span class="custom-note-label__text">${labelText.replace('(Optional)', '').trim()}</span>
          ${isOptional ? '<span class="custom-note-label__optional">' + T.optional + '</span>' : ''}
          ${isRequired ? '<span class="custom-note-label__required">*</span>' : ''}
        </div>
        <div class="custom-note-container">
          <textarea class="custom-note-textarea" placeholder="${placeholder}" maxlength="${maxLength}">${textarea.value}</textarea>
          <div class="custom-note-footer">
            <div class="custom-note-hint">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
              <span>${T.hint}</span>
            </div>
            <span class="custom-note-counter">0 / ${maxLength}</span>
          </div>
        </div>
      `;
      
      // Insert wrapper at beginning of field
      field.insertBefore(wrapper, field.firstChild);
      
      // Get new textarea and counter
      const newTextarea = wrapper.querySelector('.custom-note-textarea');
      const counter = wrapper.querySelector('.custom-note-counter');
      
      // Sync textareas
      newTextarea.addEventListener('input', function() {
        textarea.value = this.value;
        textarea.dispatchEvent(new Event('change', { bubbles: true }));
        textarea.dispatchEvent(new Event('input', { bubbles: true }));
        
        // Update counter
        const length = this.value.length;
        counter.textContent = length + ' / ' + maxLength;
        
        // Counter color
        counter.classList.remove('warning', 'danger');
        if (length > maxLength * 0.8) {
          counter.classList.add('warning');
        }
        if (length > maxLength * 0.95) {
          counter.classList.add('danger');
        }
      });
      
      // Initial count
      if (textarea.value) {
        newTextarea.value = textarea.value;
        counter.textContent = textarea.value.length + ' / ' + maxLength;
      }
    });
  }

  // =====================
  // HELPER FUNCTIONS
  // =====================
  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

})();